import { MyPageTopicGroupDetail } from '@/Interfaces/I_MyPage';
import { customAxios } from '..';

export const fetchAllMyPageTopicGroupDetails = () =>
  customAxios({
    url: 'hktv_koc/cms/myPage/topicGroups',
    method: 'GET',
  });

export const fetchAllMyPageTopicData = () =>
  customAxios({
    url: 'hktv_koc/cms/myPage/topics',
    method: 'GET',
  });

export const fetchAllMyPageTopicWithIdData = () =>
  customAxios({
    url: 'hktv_koc/cms/myPage/topics/id',
    method: 'GET',
  });

export const postMyPageTopicGroups = (data: MyPageTopicGroupDetail[]) =>
  customAxios({
    url: 'hktv_koc/cms/myPage/topicGroups',
    method: 'POST',
    data,
  });
